import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { DefaultTheme, ThemeProvider } from 'styled-components';

import AppTheme from '@webapp/theme';
import GlobalStyle from '@webapp/theme/global';

import ThemeContainer from '../theme-container';

interface ThemeWrapperProps {
  theme: DefaultTheme;
  children: React.ReactNode;
}

const mapStateToProps = (state: AppState) => ({
  theme: {
    ...AppTheme,
    colors: AppTheme.variants[state.ui.theme],
  },
});

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({
  theme,
  children,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ThemeContainer>{children}</ThemeContainer>
    </ThemeProvider>
  );
};

export default connect(mapStateToProps)(ThemeWrapper);
